
















































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class CalendarBar extends Vue {
  @Prop() public readonly calendar!: Vue;
  @Prop(String) public readonly title!: string;
  @Prop(Array) public readonly months!: Date[];
  @Prop(Number) public readonly curMonth!: number;
  @Prop(String) public readonly type!: string;
  @Inject() public readonly flags!: object;
  @Getter('cart/total') public readonly total!: number;

  public typeToLabel = {
    'month': 'Month',
    'week': 'Week',
    'day': 'Day',
    '4day': '4 Days',
  };

  private width = screen.width;

  public created() {
    window.onresize = (ev: UIEvent) => { this.width = screen.width; };
  }

  public get orientation(): string {
    if (screen.orientation) {
      return screen.orientation.type;
    }
    if (window.orientation) {
      switch (window.orientation) {
        case 0:
          return 'portrait-primary';
        case -90:
          return 'landscape-primary';
        case 90:
          return 'landscape-secondary';
        default:
          return '';
      }
    }
    return '';
  }
}
